import script from "./QVideoCustom.vue?vue&type=script&lang=ts&setup=true"
export * from "./QVideoCustom.vue?vue&type=script&lang=ts&setup=true"

import "./QVideoCustom.vue?vue&type=style&index=0&id=bca01560&lang=scss"

const __exports__ = script;

export default __exports__